import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoLong = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 205 25",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		height: 19,
		width: 21,
		y: 0,
		x: 0,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "alpha" },
		id: "mask0",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "white",
			d: "m0,0l20.901,0l0,18.4726l-20.901,0l0,-18.4726z"
		})
	}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "m22.92644,7.47607l0,17.13973l11.1928,0l0,-2.9167l-7.5978,0l0,-4.251l6.3542,0l0,-2.9172l-6.3542,0l0,-4.1376l7.4848,0l0,-2.91723l-11.0798,0z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "m36.28444,24.6158l3.5951,0l0,-17.13973l-3.5951,0l0,17.13973z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "m42.04434,23.7341l0,-3.2789c1.8841,0.9948 3.9495,1.4923 6.1957,1.4923c0.9648,0 1.6768,-0.1804 2.1369,-0.5425c0.4596,-0.3617 0.6896,-0.8364 0.6896,-1.4245c0,-0.5726 -0.2072,-1.0022 -0.6218,-1.2887c-0.4149,-0.2865 -1.1042,-0.5658 -2.069,-0.8368l-1.5378,-0.43c-0.8892,-0.256 -1.6618,-0.5535 -2.3173,-0.8933c-0.656,-0.3389 -1.2099,-0.8395 -1.6622,-1.5033c-0.4524,-0.6632 -0.6783,-1.5223 -0.6783,-2.5778c0,-1.7333 0.5234,-3.04885 1.5715,-3.94579c1.0473,-0.89648 2.5214,-1.34563 4.4205,-1.34563c1.1306,0 2.1291,0.10204 2.996,0.30566c0.8669,0.20317 1.7447,0.51657 2.6343,0.93839l0,3.16547c-1.6731,-0.9042 -3.5499,-1.357 -5.6303,-1.357c-0.8742,0 -1.4964,0.1667 -1.8654,0.4979c-0.3694,0.3316 -0.5539,0.8067 -0.5539,1.4244c0.0146,0.5881 0.1995,1.014 0.5539,1.2778c0.354,0.2637 1.014,0.5311 1.9788,0.8026l1.5598,0.4296c0.9497,0.2564 1.7642,0.5653 2.4421,0.927c0.6787,0.3617 1.2399,0.8855 1.685,1.5716c0.4441,0.686 0.6669,1.5793 0.6669,2.6794c-0.0151,1.6135 -0.5881,2.8794 -1.7188,3.7991c-1.1301,0.9197 -2.6908,1.3789 -4.6805,1.3789c-2.3369,0 -4.4018,-0.4214 -6.1957,-1.2659z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "m69.17167,10.5741l-4.7936,0l0,14.0417l-3.6183,0l0,-14.0417l-4.7935,0l0,-3.09803l13.2054,0l0,3.09803z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "m82.52937,21.6991l0,2.9167l-11.1928,0l0,-17.13973l11.0799,0l0,2.91723l-7.4849,0l0,4.138l6.3542,0l0,2.9168l-6.3542,0l0,4.251l7.5978,0z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "m88.18767,15.0961l3.0981,0c1.7784,0 2.668,-0.7534 2.668,-2.2612c0,-0.799 -0.2186,-1.383 -0.6555,-1.7529c-0.4378,-0.369 -1.1083,-0.5535 -2.0125,-0.5535l-3.0981,0l0,4.5676zm2.2613,3.0525l-2.2613,0l0,6.4667l-3.5955,0l0,-17.13971l6.6936,0c4.2059,0 6.3086,1.78658 6.3086,5.35931c0,2.6229 -1.1684,4.2815 -3.5048,4.9744l4.2282,6.806l-4.0246,0l-3.8442,-6.4667z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FA6450",
			d: "m100.48837,23.7341l0,-3.2789c1.884,0.9948 3.95,1.4923 6.196,1.4923c0.965,0 1.677,-0.1804 2.137,-0.5425c0.459,-0.3617 0.689,-0.8364 0.689,-1.4245c0,-0.5726 -0.207,-1.0022 -0.621,-1.2887c-0.415,-0.2865 -1.105,-0.5658 -2.069,-0.8368l-1.538,-0.43c-0.889,-0.256 -1.662,-0.5535 -2.318,-0.8933c-0.656,-0.3389 -1.209,-0.8395 -1.662,-1.5033c-0.452,-0.6632 -0.678,-1.5223 -0.678,-2.5778c0,-1.7333 0.523,-3.04885 1.572,-3.94579c1.047,-0.89648 2.521,-1.34563 4.42,-1.34563c1.131,0 2.129,0.10204 2.996,0.30566c0.867,0.20317 1.745,0.51657 2.634,0.93839l0,3.16547c-1.673,-0.9042 -3.55,-1.357 -5.63,-1.357c-0.874,0 -1.496,0.1667 -1.865,0.4979c-0.37,0.3316 -0.554,0.8067 -0.554,1.4244c0.014,0.5881 0.199,1.014 0.554,1.2778c0.354,0.2637 1.014,0.5311 1.978,0.8026l1.56,0.4296c0.95,0.2564 1.764,0.5653 2.442,0.927c0.679,0.3617 1.24,0.8855 1.685,1.5716c0.444,0.686 0.667,1.5793 0.667,2.6794c-0.015,1.6135 -0.588,2.8794 -1.719,3.7991c-1.13,0.9197 -2.69,1.3789 -4.68,1.3789c-2.337,0 -4.402,-0.4214 -6.196,-1.2659z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FA6450",
			d: "m123.46642,17.9906l0,6.6252l-3.528,0l0,-6.6252l-5.947,-10.51453l3.618,0l4.093,7.37183l4.115,-7.37183l3.618,0l-5.969,10.51453z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FA6450",
			d: "m130.2038,23.7341l0,-3.2789c1.884,0.9948 3.949,1.4923 6.196,1.4923c0.964,0 1.676,-0.1804 2.136,-0.5425c0.46,-0.3617 0.69,-0.8364 0.69,-1.4245c0,-0.5726 -0.207,-1.0022 -0.622,-1.2887c-0.415,-0.2865 -1.104,-0.5658 -2.069,-0.8368l-1.538,-0.43c-0.889,-0.256 -1.661,-0.5535 -2.317,-0.8933c-0.656,-0.3389 -1.21,-0.8395 -1.662,-1.5033c-0.452,-0.6632 -0.678,-1.5223 -0.678,-2.5778c0,-1.7333 0.523,-3.04885 1.571,-3.94579c1.048,-0.89648 2.521,-1.34563 4.421,-1.34563c1.131,0 2.129,0.10204 2.996,0.30566c0.867,0.20317 1.744,0.51657 2.634,0.93839l0,3.16547c-1.673,-0.9042 -3.55,-1.357 -5.63,-1.357c-0.875,0 -1.496,0.1667 -1.866,0.4979c-0.369,0.3316 -0.554,0.8067 -0.554,1.4244c0.015,0.5881 0.2,1.014 0.554,1.2778c0.354,0.2637 1.014,0.5311 1.979,0.8026l1.56,0.4296c0.95,0.2564 1.764,0.5653 2.442,0.927c0.679,0.3617 1.24,0.8855 1.685,1.5716c0.444,0.686 0.667,1.5793 0.667,2.6794c-0.016,1.6135 -0.588,2.8794 -1.719,3.7991c-1.13,0.9197 -2.69,1.3789 -4.68,1.3789c-2.337,0 -4.402,-0.4214 -6.196,-1.2659z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FA6450",
			d: "m157.19117,10.5741l-4.793,0l0,14.0417l-3.618,0l0,-14.0417l-4.794,0l0,-3.09803l13.205,0l0,3.09803z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FA6450",
			d: "m170.54917,21.6991l0,2.9167l-11.193,0l0,-17.13973l11.08,0l0,2.91723l-7.485,0l0,4.138l6.355,0l0,2.9168l-6.355,0l0,4.251l7.598,0z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FA6450",
			d: "m190.10317,7.47607l0,17.13973l-3.596,0l0,-11.9617l-4.228,6.0827l-1.809,0l-4.161,-6.0372l0,11.9162l-3.595,0l0,-17.13973l4.115,0l4.568,6.71583l4.568,-6.71583l4.138,0z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FA6450",
			d: "m192.26817,23.7341l0,-3.2789c1.884,0.9948 3.949,1.4923 6.196,1.4923c0.964,0 1.676,-0.1804 2.136,-0.5425c0.46,-0.3617 0.69,-0.8364 0.69,-1.4245c0,-0.5726 -0.207,-1.0022 -0.622,-1.2887c-0.415,-0.2865 -1.104,-0.5658 -2.069,-0.8368l-1.538,-0.43c-0.889,-0.256 -1.661,-0.5535 -2.317,-0.8933c-0.656,-0.3389 -1.21,-0.8395 -1.662,-1.5033c-0.452,-0.6632 -0.678,-1.5223 -0.678,-2.5778c0,-1.7333 0.523,-3.04885 1.571,-3.94579c1.048,-0.89648 2.521,-1.34563 4.421,-1.34563c1.131,0 2.129,0.10204 2.996,0.30566c0.867,0.20317 1.744,0.51657 2.634,0.93839l0,3.16547c-1.673,-0.9042 -3.549,-1.357 -5.63,-1.357c-0.875,0 -1.496,0.1667 -1.866,0.4979c-0.369,0.3316 -0.554,0.8067 -0.554,1.4244c0.015,0.5881 0.2,1.014 0.554,1.2778c0.354,0.2637 1.014,0.5311 1.979,0.8026l1.56,0.4296c0.95,0.2564 1.764,0.5653 2.442,0.927c0.679,0.3617 1.24,0.8855 1.685,1.5716c0.444,0.686 0.667,1.5793 0.667,2.6794c-0.016,1.6135 -0.588,2.8794 -1.719,3.7991c-1.13,0.9197 -2.69,1.3789 -4.68,1.3789c-2.337,0 -4.402,-0.4214 -6.196,-1.2659z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "m20.3006,8.20947l0,16.40633l-4.3184,0l0,-11.5486l4.3184,-4.85773z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "m4.31854,20.1043l-4.31842,-4.3768l0,8.8879l4.31842,0l0,-4.5111z",
			clipRule: "evenodd",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#FA6450",
				d: "m7.11753,12.1599l-7.11765,-7.20374l0,6.29494l7.12903,7.2215l13.77199,-15.48251l0,-2.99009l-13.78337,12.1599z",
				clipRule: "evenodd",
				fillRule: "evenodd"
			})
		})
	] })]
});
export default SvgLogoLong;
